import { render, staticRenderFns } from "./Mortgage.vue?vue&type=template&id=196e4b08"
import script from "./Mortgage.vue?vue&type=script&lang=js"
export * from "./Mortgage.vue?vue&type=script&lang=js"
import style0 from "./Mortgage.vue?vue&type=style&index=0&id=196e4b08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports